import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticatedContainerComponent } from './components/authenticated-container/authenticated-container.component';
import { LoginGuard } from './services/guards/login.guard';
import { ReturnGuard } from './services/guards/return.guard';
import { RedeemGuard } from './services/guards/redeem.guard';
import { GmvehiclesComponent } from './components/gmvehicles/gmvehicles.component';
import { RedeemPointsComponent } from './components/redeem-points/redeem-points.component';
import { OldcardtypeGuard } from './services/guards/oldcardtype.guard';
import { NewcardtypeGuard } from './services/guards/newcardtype.guard';
import { DashboardComponent } from './components/dashboard/dashboard.component';

const routes: Routes = [
  {
    path: 'route/:trackId',
    canActivate: [ReturnGuard],
    component: AuthenticatedContainerComponent
  },
  {
    path: '',
    component: AuthenticatedContainerComponent,
    canActivate: [LoginGuard],
    children: [
      // GMB routes
      { path: '',
        canActivate: [NewcardtypeGuard],
        children: [
          { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
          { path: 'dashboard', component: DashboardComponent },
          { path: 'redeem-points', component: RedeemPointsComponent },
          { path: 'gmvehicles', component: GmvehiclesComponent },
          { path: '**', redirectTo: 'dashboard', pathMatch: 'full'},
        ]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticatedRoutingModule {}
